import { combineReducers } from 'redux';
import { neolidsReducer } from 'Store/seller/neolidsReducer';
import { sellerInfoReducer } from 'Store/seller/sellerInfoReducer';
export default combineReducers({
  neolids: neolidsReducer,
  sellerInfo: sellerInfoReducer,
});
